import TrainsHeaderBaseController from '../../trains-base/controllers/trains-header-base-controller';

export default function TrainsHeaderController(
    $scope,
    $controller,
    trainsFactory
) {
    'ngInject';

    $controller(TrainsHeaderBaseController, {
        $scope,
        trainsFactory,
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/train/controllers/trains-headers-controller.js